import React, { useEffect, useState } from 'react';
import { apiGet } from '../api';
import StatCard from './StatCard';

const Dashboard = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    apiGet('/api/admin/stats')
      .then((s) => { if (alive) { setSummary(s); setLoading(false); } })
      .catch(() => { if (alive) { setError('Failed to load dashboard data.'); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  if (error) {
    return (
      <div className="dark-page">
        <div className="dark-error"><i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />{error}</div>
      </div>
    );
  }

  return (
    <div className="dark-page">
      <h2>Dashboard Overview</h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: 16
      }}>
        <StatCard icon="fa-solid fa-paper-plane"        title="My Total Sent"      value={summary?.myTotalSent || 0}      color="#3b82f6" usePreciseFormat isLoading={loading} />
        <StatCard icon="fa-solid fa-globe"              title="All Admins' Sent"   value={summary?.totalAdminSent || 0}   color="#8b5cf6" usePreciseFormat isLoading={loading} />
        <StatCard icon="fa-solid fa-building"           title="Total Agencies"     value={summary?.totalAgency || 0}      color="#10b981" usePreciseFormat isLoading={loading} />
        <StatCard icon="fa-solid fa-users"              title="Total Resellers"    value={summary?.totalReseller || 0}    color="#f59e0b" usePreciseFormat isLoading={loading} />
        <StatCard icon="fa-solid fa-user-group"         title="Total Users"        value={summary?.totalUsers || 0}       color="#ff4d6d" usePreciseFormat isLoading={loading} />
      </div>
    </div>
  );
};

export default Dashboard;
